import React, { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * PaySheet — popup que enfoca una sola sección del Centro de Pagos.
 *
 * Se monta con portal en <body> y con z-index por encima del modal de
 * Bootstrap, así que no depende del stacking context del Centro de Pagos.
 *
 * Requiere pay-mdl.css
 */
export default function PaySheet({ open, title, onClose, children }) {
   useEffect(() => {
      if (!open) return;
      const onKey = (e) => e.key === "Escape" && onClose();
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
   }, [open, onClose]);

   if (!open) return null;

   return createPortal(
      <div className="pay-sheet-backdrop" onClick={onClose}>
         <div
            className="pay-sheet"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            onClick={(e) => e.stopPropagation()}
         >
            <div className="pay-sheet-grip" aria-hidden="true" />

            <header className="pay-sheet-head">
               <h3 className="pay-sheet-title">{title}</h3>
               <button
                  type="button"
                  className="pay-sheet-close"
                  aria-label="Cerrar"
                  onClick={onClose}
               >
                  <i className="uil uil-times" />
               </button>
            </header>

            <div className="pay-sheet-body">{children}</div>

            <footer className="pay-sheet-foot">
               <button type="button" className="pay-sheet-done" onClick={onClose}>
                  Listo
               </button>
            </footer>
         </div>
      </div>,
      document.body
   );
}